import { render } from "./CPageRightSidebar.vue?vue&type=template&id=23802824"
const script = {}

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_ejoqcbfru5qt7peog562lsj5cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__